import { useAuth } from "@/lib/auth";
import useSiteSettings from "@/lib/useSiteSettings";
import WikiComingSoon from "@/pages/WikiComingSoon";

/**
 * Wraps any /wiki/* route. When `wiki_restricted` is enabled in site settings
 * and the visitor is NOT an admin, renders the "Coming Soon" placeholder
 * instead of the wrapped page.
 */
export default function WikiGate({ children }) {
  const { user, loading: authLoading } = useAuth();
  const { settings, loading: settingsLoading } = useSiteSettings();

  // While either check is loading, render nothing to avoid a flash of content.
  if (authLoading || settingsLoading) return null;

  if (settings.wiki_restricted && !user?.is_admin) {
    return <WikiComingSoon />;
  }
  return children;
}
